module.exports = __webpack_public_path__ + "img/beer_id-2.acf89962.png";